# Used in SME Credit.
# Each bubble corresponds to an industry branch, a click should trigger the proper value in the hidden field and apply
# a specific product image that'll be used throughout the whole process

BUBBLE_SELECTED_CLASS = 'list-bubbles-entry--selected'
BG_CLASS_WILDCARD     = 'background-credit'
BG_SELECTOR           = "[class*='#{BG_CLASS_WILDCARD}']"
TYPE                  = Object.freeze(SECTOR: 'sector', AMOUNT: 'amount')

changeBackground = (key) ->
  $bg = $(BG_SELECTOR)
  if $bg.is(BG_SELECTOR)?
    $bg.removeClass (index, classes) ->
      re = ///#{BG_CLASS_WILDCARD}\S+///g
      classes.match(re)?.join(' ') || []
  $bg.addClass "#{BG_CLASS_WILDCARD}--#{key}"

setupBubbleSelection = ->
  $('[data-behaviour="bubble-selection"]').each ->
    $el = $ @
    value = $el.data('value')
    $($el.data('input'))[0].value = value
    $el.find("[data-value='#{value}']").addClass(BUBBLE_SELECTED_CLASS) if value
    changeBackground(value) if $el.data('type') == TYPE.SECTOR

$(document).on 'click', '[data-behaviour="bubble-selection"] > li', ->
  $el = $(@).parent()
  $el.find(".#{BUBBLE_SELECTED_CLASS}").removeClass BUBBLE_SELECTED_CLASS
  $li = $(@).addClass BUBBLE_SELECTED_CLASS
  $input = $ $($el.data('input'))[0]
  itemValue = $li.data('value') || ''

  if $el.data('type') == TYPE.SECTOR
    if itemValue != $input.val() || $input.val() == ''
      $input.val itemValue
      changeBackground itemValue

  if $el.data('type') == TYPE.AMOUNT
    $input.val itemValue
    if itemValue == ''
      $input.parent().css('display', 'block')
      $input.focus()
    else
      $input.parent().css('display', 'none')

$(document).ready(setupBubbleSelection)